import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ReportMenu.css';

function InformationMenu({ sessionId, onLeafClick, visible, onClose }) {
  const [currentNode, setCurrentNode] = useState(null);
  const [children, setChildren] = useState([]);
  const [parentId, setParentId] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      loadMenu('suggestions_root');
    }
  }, [visible]);

  const loadMenu = async (nodeId) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `https://demo.iresponse.co.in/cb_api/suggestions/navigate`,
        { session_id: sessionId, node_id: nodeId },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.status === 'success') {
        setCurrentNode(response.data.current_node);
        setChildren(response.data.children);
        setParentId(response.data.parent_id);
        setBreadcrumb(response.data.breadcrumb);
        console.log('💬 Navigated to:', response.data.current_node.label);
      }
    } catch (error) {
      console.error('❌ Error loading information menu:', error);
      alert('Failed to load information menu. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleNodeClick = (node) => {
    if (node.type === 'leaf') {
      console.log('📄 Leaf clicked:', node.section);
      onLeafClick(node.section, node.label);
    } else {
      loadMenu(node.id);
    }
  };

  const handleBack = () => {
    if (parentId) {
      loadMenu(parentId);
    } else {
      onClose();
    }
  };

  if (!visible) return null;

  return (
    <div className="report-menu-overlay">
      <div className="report-menu-container">
        {/* Header */}
        <div className="report-menu-header">
          <div className="header-content">
            <h2 className="report-title">
              {currentNode?.label?.replace(/📄|📊|🔥|🌊|🌡️|❄️|📁/g, '').trim() || 'Information'}
            </h2>

            {breadcrumb.length > 2 && (
<div className="breadcrumb-path" title={breadcrumb.slice(1).join(' › ')}>
                {breadcrumb.slice(1).map((crumb, idx) => (
                  <React.Fragment key={idx}>
                    <span className="breadcrumb-item">{crumb}</span>
                    {idx < breadcrumb.slice(1).length - 1 && (
                      <span className="breadcrumb-separator">›</span>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>

          <button className="close-menu-btn" onClick={onClose} title="Close menu">
            ✕
          </button>
        </div>

        {/* Navigation Buttons */}
        <div className="menu-navigation-buttons">
          {(parentId || currentNode?.id === 'suggestions_root') && (
            <button className="back-btn" onClick={handleBack}>
              ← {parentId ? 'Back' : 'Main Menu'}
            </button>
          )}

          {currentNode?.id !== 'suggestions_root' && parentId && (
            <button className="main-menu-btn" onClick={() => loadMenu('suggestions_root')}>
              🏠 Information Menu
            </button>
          )}
        </div>

        {/* Menu Items Grid */}
        <div className="menu-items-grid">
          {loading ? (
            <div className="menu-loading">
              <div className="spinner"></div>
              <p>Loading menu...</p>
            </div>
          ) : (
            children.map((child) => (
              <button
                key={child.id}
                className="menu-item"
                onClick={() => handleNodeClick(child)}
                disabled={loading}
              >
                <span className="menu-item-icon">
                  {child.icon || (child.type === 'leaf' ? '📄' : '📁')}
                </span>

                <span className="menu-item-label">{child.label}</span>

                {/* Arrow only for container nodes (has deeper hierarchy) */}
                {child.type !== 'leaf' && (
                  <span className="menu-item-arrow">→</span>
                )}
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default InformationMenu;